<!-- Template -->
<template>
  <header v-bind:class="{open: isToggled }">
    <!-- Logo -->
    <div @click="toggleHeader" class="brandBloc">
      <div class="logoGlasses">
        <span class="fontPicto fmix-glasses"></span>
      </div>
      <div class="fmixlabMultimedia">
        <h1>fmixlab multimedia</h1>
        <h2>Graphic design &amp; Web development</h2>
      </div>
    </div>
    <!-- Main Nav -->
    <nav class="mainNav">
      <ul>
        <li>
          <a @click="goHomePage">About</a>
        </li>
        <li>
          <a @click="goProjectsPage">Projects</a>
        </li>
      </ul>
    </nav>
    <!-- Contact Nav -->
    <div class="bottomBloc">
      <ul class="contactNav">
        <li>
          <a href="mailto:contact@fmixlab.com">
            <span class="icon fmix-mail"></span>
            contact@fmixlab.com
          </a>
        </li>
        <li>
          <a href="skype:fmixagent?call">
            <span class="fmix-skype">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
            </span>
            fmixagent
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/fmixlab/">
            <span class="icon fmix-facebook"></span>
            fmixlab
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<!-- Scripts -->
<script>
export default {
  name: 'AppHeader',
  data () {
    return {
      isToggled: false
    }
  },
  methods: {
    toggleHeader: function (event) {
      this.isToggled = !this.isToggled
    },
    goHomePage: function (event) {
      this.$router.push({name: 'HomePage'})
      this.isToggled = false
    },
    goProjectsPage: function (event) {
      this.$router.push({name: 'ProjectsPage'})
      this.isToggled = false
    }
  }
}
</script>

<!-- Styles -->
<style lang="scss">

// Transitions
$time1:0.2s;
$time2:0.2s;
header {
  transition-timing-function: linear;
  transition-duration: $time1;
  transition-property: all;
  .logoGlasses {
    transition-timing-function: linear;
    transition-duration: $time1;
    transition-property: all;
  }
  .fontPicto {
    transition-timing-function: linear;
    transition-duration: $time1;
    transition-property: font-size;
  }
  .fmixlabMultimedia {
    transition-timing-function: ease-out;
    transition-duration: $time2;
    transition-property: all;
  }
  .contactNav {
    transition-delay: 0.1s;
    transition-timing-function: ease-out;
    transition-duration: $time2;
    transition-property: all;
  }
  .mainNav {
    transition-delay: 0.2s;
    transition-timing-function: ease-out;
    transition-duration: $time2;
    transition-property: all;
  }
}
main {
  transition-timing-function: linear;
  transition-duration: $time1;
  transition-property: all;
}

// Styles
header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background-color: $brandYellow;
  border-right: 1px solid #c2c2c2;
  width: $headerOpenW;
  overflow: hidden;

  .brandBloc {
    position: relative;
    height: 200px;
    cursor: pointer;
    @include disable-select;
    .logoGlasses {
      position: relative;
      padding-top: 2*$gutter;
      padding-bottom: $gutter;
      text-align: center;
    }

    .fontPicto {
      font-size: 50px;
    }

    .fmixlabMultimedia {
      position: absolute;
      width: $headerOpenW;
      top:80px;

      padding: $gutter;
      h1, h2 {
        width: 100%;
        color: $baseDarkGrey;
        text-align: center;
      }

      h1 {
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 0;
      }

      h2 {
        font-weight: 400;
        font-size: 18px;
        margin-top: 0;
      }
    }

  }

  .bottomBloc {
    width: $headerOpenW;
    height: 200px;
    display: flex;
    align-items: flex-end;
  }
  .contactNav {
    clear: both;
    list-style: none;
    margin: 0;
    padding:0;
    padding: $gutter;
    li {
      font-size: 18px;
      padding-bottom: 0.6em;
      &:last-child {
        padding-bottom: 0;
      }
      a {
        color: $baseDarkGrey;
        text-decoration: none;
        &:hover {
            color: $baseDarkGrey;
            text-decoration: none;
        }
      }
      .icon {
        padding-right: 0.2em;
        position: relative;
        top: 0.2em;
        font-size: 1.4em;
        color: $baseDarkGrey;
      }
    }
  }

  .mainNav {
    clear: both;
    width: $headerOpenW;
    ul {
      list-style: none;
      margin: 0;
      padding:0;

      li {
        font-size: 20px;
        padding: 2px 0;
        margin: 0 $gutter;
        text-align: right;
        border-bottom: 1px dotted rgba($baseDarkGrey,0.5);
        a {
          cursor: pointer;
          color: $baseDarkGrey;
          text-decoration: none;
          display: inline-block;
          padding-top: 8px;
          padding-bottom: 8px;
          width: 100%;
          text-align: right;
          &:hover {
              color: $baseDarkGrey;
              text-decoration: none;
          }
          &.selected {
              color: $baseDarkGrey;
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}

// Tablets
@media only screen and (max-width: 1200px) {
  header {
    position: fixed;
    overflow: hidden;
    width: $headerClosedTabletW;
    height: 100vh;
    z-index: 100;

    .brandBloc{
      .logoGlasses {
        position: relative;
        padding-top: $gutter/2;
      }
      .fontPicto {
        font-size: 24px;
      }
    }
    .fmixlabMultimedia,
    .contactNav,
    .mainNav {
      opacity: 0;
    }

    &.open {
      width: $headerOpenW;
      .brandBloc{
        .logoGlasses {
          position: relative;
          padding-top: 2*$gutter;
        }
        .fontPicto {
          font-size: 50px;
        }
      }
      .fmixlabMultimedia,
      .contactNav,
      .mainNav {
        opacity: 1;
      }
      &+main {
        padding-left: $headerOpenW;
      }
    }

  }
  main {
    width: 100%;
    padding-left: $headerClosedTabletW;
  }
}

// Mobile
@media only screen and (max-width: 767px) {
  header {
    position: fixed;
    left: 0;
    overflow: hidden;
    width: $headerClosedMobileW;
    height: 100vh;
    z-index: 2;

    .brandBloc{
      .logoGlasses {
        position: fixed;
        left: 0;
        border-radius: 40px;
        width: 60px;
        height: 60px;
        padding: 0;
        padding-top: 17px;
        margin: $gutter/2;
        background-color: $brandYellow;
        opacity: 0.8;
      }
      .fontPicto {
        font-size: 24px;
      }
    }
    .fmixlabMultimedia,
    .contactNav,
    .mainNav {
      opacity: 0;
    }

    &.open {
      width: $headerOpenW;
      .brandBloc{
        .logoGlasses {
          position: fixed;
          left: 85px;
          width: auto;
          margin: 0;
          padding-bottom: $gutter;
          padding-top: 2*$gutter;
        }
        .fontPicto {
          font-size: 50px;
        }
      }
      .fmixlabMultimedia,
      .contactNav,
      .mainNav {
        opacity: 1;
      }
    }

  }
  main {
    width: 100%;
    padding-left: $headerClosedMobileW;
  }
}

@media only screen and (max-height: 375px) {
  header {
    .brandBloc{
      height: 90px;
      .logoGlasses {
        padding-top: 23px !important;
        padding-left: 12px;
        text-align: left !important;
      }
      .fontPicto {
        font-size: 26px !important;
      }
    }
    .fmixlabMultimedia {
      top: 0 !important;
      padding-top: 0 !important;
      padding-bottom: 20px !important;
      padding-left: 72px !important;
      padding-right: 0 !important;
      h1 {
        text-align: left !important;
        font-size: 20px !important;
      }
      h2 {
        text-align: left !important;
        font-size: 14px !important;
      }
    }
    .contactNav {
      padding-left: 20px;
      padding-bottom: 20px;
      li {
        padding-bottom: 0.2em;
      }
    }
    .bottomBloc {
      height: 130px;
    }
    .fmixlabMultimedia,
    .contactNav,
    .mainNav {
      opacity: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue